import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetTariffsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.form-default-values';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoTariffListContextProvider,
  useEmspBoTariffListContext,
} from '../emsp-bo-tariff.context';
import { EmspBoTariffListFilterFormController } from './emsp-bo-tariff-list-filter-form/emsp-bo-tariff-list-filter-form.controller';

interface EmspBoTariffListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoTariffListFilterController = ({
  onCancel,
  onSuccess,
}: EmspBoTariffListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoTariffListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetTariffsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-tariff-list-filter.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      id: fieldValues.id || undefined,
      cpoId: fieldValues.cpoId,
      createdAfter: fieldValues.createdAfter,
      createdBefore: fieldValues.createdBefore,
      updatedAfter: fieldValues.updatedAfter,
      updatedBefore: fieldValues.updatedBefore,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetTariffsPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterEmspBoTariffListContextProvider data={data}>
      <EmspBoTariffListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterEmspBoTariffListContextProvider>
  );
};
